import { combineReducers } from "redux";
import { reducer as form } from "redux-form";
import { reducer as toastr } from "react-redux-toastr";

import themeReducer from './themeReducer';
import rtlReducer from './rtlReducer';
import sidebarReducer from './sidebarReducer';
import cryptoTableReducer from './cryptoTableReducer';
import newOrderTableReducer from './newOrderTableReducer';
import customizerReducer from './customizerReducer';
import todoReducer from './todoReducer';
import user from "./user";
import token from "./token";
import logged_user from "./logged_user";
import collections from "./collections";
import asset_types from "./asset_types";
import process_types from "./process_types";
import selected_collection from "./selected_collection";
import assetsManagementReducer from "./assetsManagement";
import componentReducer from "./componentReducer";
import feedbackReducer from "./feedbackReducer";
import eventManagementReducer from "./eventManagement";
import reportReducer from "./reportReducer";
import dashboard from "./dashboard";
import language from "./language";
import inference from "./inferenceReducer";

const rootReducer = combineReducers({
  theme: themeReducer,
  rtl: rtlReducer,
  sidebar: sidebarReducer,
  cryptoTable: cryptoTableReducer,
  newOrder: newOrderTableReducer,
  customizer: customizerReducer,
  todos: todoReducer,
  user,
  token,
  logged_user,
  form,
  toastr,
  collections,
  asset_types,
  process_types,
  selected_collection,
  assetsManagement: assetsManagementReducer,
  component : componentReducer,
  feedback : feedbackReducer,
  eventManagement : eventManagementReducer,
  reports :reportReducer,
  dashboard,
  language,
  inference,
});

export default rootReducer;
